document.addEventListener('DOMContentLoaded', () => {

  const storySwiper = new Swiper('.storySwiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
    },
    breakpoints: {
      969: {
        slidesPerView: 2,
      },
      1201: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      1441: {
        slidesPerView: 4,
      },
    }
  });
});
